import billingSDK from '@/assets/js/shared/services/billing-sdk';
import billingV2SDK from '@/assets/js/shared/services/billing-v2-sdk';
import billingProcessorSDK from '@/assets/js/shared/services/billing-processor-sdk';

const paymentHelper = {
  async getPreferredPayment(user, $bugsnag = {}) {
    try {
      let payments;
      if (!user.user_data?.v2) {
        payments = await billingSDK(window).Billing.Payments.byAccount(
          user.domain,
          user.id
        );
      } else {
        payments = await billingProcessorSDK(window).Payment.List.byAccount(
          user.domain,
          user.id
        );
      }
      if (
        typeof payments === 'string' ||
        (payments.type && payments.type.includes('error'))
      ) {
        throw new Error('Error Fetching Preferred Payment');
      }
      return payments.find(payment => payment.preferred_payment);
    } catch (err) {
      console.error('Error Fetching Preferred Payment');
      $bugsnag?.notify?.(err, event => {
        event.addMetadata('Extra Info', {
          userId: user?.id,
          domain: user?.domain,
          isV2: !!user?.user_data?.v2
        });
      });
      return false;
    }
  },
  async chargeCard(
    paymentData,
    product,
    userData,
    aid,
    extra_tracking,
    type = 'product',
    $bugsnag = {}
  ) {
    const { city, state, country } = userData;
    const productId =
      product && typeof product === 'object' ? product.id : product;

    if (!productId) {
      const err = new Error('chargeCard called without a valid product id');
      $bugsnag?.notify?.(err, event => {
        event.addMetadata('Extra Info', {
          method: 'chargeCard',
          userId: userData?.id,
          domain: userData?.domain,
          isV2: !!userData?.user_data?.v2,
          receivedProduct: product,
          paymentDataId: paymentData?.id,
          hasToken: !!paymentData?.token,
          hasFingerprint: !!paymentData?.fingerprint
        });
      });
      return false;
    }

    const body = {
      currency_code: 'USD',
      line_items: [
        {
          id: productId,
          qty: 1,
          type
        }
      ],
      data: {
        city,
        state,
        country,
        aid,
        extra_tracking
      }
    };
    try {
      let billingRes;
      if (!userData.user_data?.v2) {
        const { token, fingerprint } = paymentData;
        billingRes = await billingSDK(window).Charge.byToken(
          body,
          userData.domain,
          token,
          fingerprint,
          userData.id,
          true
        );
      } else {
        billingRes = await billingV2SDK(window).Charge.byPayment(
          body,
          userData.domain,
          paymentData.id,
          userData.id,
          true
        );
      }
      return !(billingRes.type && billingRes.type.includes('error'));
    } catch (err) {
      console.error(err);
      $bugsnag?.notify?.(err, event => {
        event.addMetadata('Extra Info', {
          method: 'chargeCard',
          userId: userData?.id,
          domain: userData?.domain,
          isV2: !!userData?.user_data?.v2,
          receivedProduct: product,
          paymentDataId: paymentData?.id,
          hasToken: !!paymentData?.token,
          hasFingerprint: !!paymentData?.fingerprint
        });
      });
      return false;
    }
  }
};

export default paymentHelper;
